import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';


export const finishRegisterPatientStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, cb}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'registerPatientStep5',
        title: 'Crear paciente',
        text: 'Una vez que hayas ingresado los datos del paciente, tendrás que dar clic en el botón para poder crear al paciente.',
        canClickTarget: false,
        attachTo: {
          element: '.btn-register',    // @ts-ignore
          on: 'bottom'
        },
        buttons: [
          {
            text: 'Entendido',
            // tslint:disable-next-line:typedef
            action()  {
              return this.next();
            },
          },
          {...buttons.cancel},
        ]
      },
      {
        ...steps.default,
        id: 'registerPatientStep6',
        title: 'Tour finalizado',
        text: '¡Muy bien!. Has finalizado el tour de "Crear paciente".',
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('goToTours');
            },
            text: 'Ir al listado de tours',
            classes: 'shepherd-button shepherd-button-secondary',
          },
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('continue');
            },
            text: 'Mantenerme aquí'
          },
          {...buttons.cancel}
        ]
      }
    ];
  };
